module.exports = __webpack_public_path__ + "static/startup_shap-ad96aba577f48bfe86b3e80256395903.png";